module.exports = __webpack_public_path__ + "assets/img/tx266_3.1c0bb3d9.jpg";